import $ from 'jquery';

import moment from 'moment';

import application from 'application/application';

const controller = 'DefaultPublicationsController';

application

	.controller(controller, ['$scope', '$http', '$state', '$stateParams', 'API', 'helper', ($scope, $http, $state, $stateParams, API, helper) => {

		$scope.filterPublicationsMax = moment().add(5, 'day');

		$scope.filterPublicationsStart = moment().subtract(15, 'day');

		$scope.filterPublicationsEnd = moment().add(5, 'day');

		$scope.filterPublicationsFormat = 'DD/MM/YYYY';

		$scope.filterPublicationsMaxRange = 60;

		/** Instância de armazenamento de resposta. */
		$scope.publications = helper.responseStore()

			.setItemsPerPage(10);

		/** Define a página atual com base na URL. */

		if ($stateParams.paginaAtual !== undefined)

			$scope.publications.setCurrentPage($stateParams.paginaAtual);

		let

			/** Lista de filtros possíveis. */
			publicationsFiltersNames = [
				'q',
				'visualizada',
				'favorita',
				'arquivada',
				'dataPublicacao',
				'idPalavraChave',
				'idDiario',
				'vara',
				'comarca'
			];

		/** Define os filtros informados na URL. */
		publicationsFiltersNames.forEach(name => {

			let value = $stateParams[name];

			if (value !== undefined)

				$scope.publications.setFilter(name, value);

		});

		/** Define uma cópia dos filtros atuais para ser usados como modelo. */
		$scope.filtersPublications = helper.cloneSimpleObject($scope.publications.getFilters());

		/** Define valores padrões padrões para criar um item */
		const

			defaultPublications = {
				nome : '',
				ativo: true,
				aplicacoes: []
			};

		/** Cria item em vazio para ser preenchido. */
		$scope.emptyEmployeeProfile = helper.cloneSimpleObject(defaultPublications);

		/** Cria item em vazio para ser preenchido. */
		$scope.editableEmployeeProfile = {
			nome: '',
			ativo: '',
			aplicacoes: []
		};

		/**
		 * Recupera perfis.
		 *
		 * @param {ResponseStore} responseStore - Instância de armazenamento de resposta.
		 *
		 * @example
		 * // Cria uma instância de armazenamento de resposta.
		 * $scope.publications = helper.responseStore();
		 *
		 * // Recupera as aplicações.
		 * $scope.recordPublications($scope.publications);
		 */
		$scope.recordPublications = responseStore => {

			$http({
				...helper.http(API.publications, 'GET'),
				params: {
					...helper.httpFields([
						'id',
						'dataPublicacao',
						'dataDisponibilizacao',
						'numeroProcesso',
						'idPalavraChave',
						'idDiario'
					]),
					paginaAtual: responseStore.getCurrentPage(),
					registrosPorPagina: responseStore.getItemsPerPage(),
					...responseStore.getFilters()
				}
			})

				.then(response => {

					responseStore.setItems(response.data.itens);

					$scope.publicationsLength = response.data.paginacao.totalRegistros;

					$scope.publicationsPagesLength = Math.ceil($scope.publicationsLength / responseStore.getItemsPerPage());

				})

				.finally(() => responseStore.setReady(true));

		};

		$scope.recordPublications($scope.publications);

		/**
		 * Filtra os perfis de colaboradores.
		 *
		 * @param {Object} filters - Objeto com filtros.
		 */
		$scope.filterPublications = filters => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			Object.keys(filters).forEach(filter => params[filter] = filters[filter]);

			$state.go($state.current.name, params, { inherit: false, reload: 'root.default.publications' });

		};

		/**
		 * Remove um filtro dos perfis de colaboradores.
		 *
		 * @param {String} filter - Filtro a ser removido.
		 */
		$scope.removePublicationsFilter = filter => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			delete params[filter];

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 * Limpa os filtros dos perfis de colaboradores.
		 */
		$scope.clearPublicationsFilters = () => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			publicationsFiltersNames.forEach(name => delete params[name]);

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 * Verifica se existe uma página anterior à atual.
		 */
		$scope.hasPublicationsPrevPage = () => ($stateParams.paginaAtual ? +$stateParams.paginaAtual : 1) > 1;

		/**
		 * Navega para a primeira página.
		 */
		$scope.recordPublicationsFirstPage = () => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 * Navega para a página anterior.
		 */
		$scope.recordPublicationsPrevPage = () => {

			let params = helper.cloneSimpleObject($stateParams);

			let currentPage = params.paginaAtual ? Number(params.paginaAtual): 1;

			params.paginaAtual = currentPage > 1 ? currentPage - 1 : 1;

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 * Navega para a próxima página.
		 */
		$scope.recordPublicationsNextPage = () => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = params.paginaAtual ? Number(params.paginaAtual) + 1 : 2;

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 *
		 */
		$scope.favoritePublications = (responseStore, publications) => {

			if (!Array.isArray(publications)) publications = [ publications ];

			$http({
				...helper.http(API.publications, 'favorite'),
				method: 'PUT',
				data: {
					itens: publications
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(publications))

				.finally(() => responseStore.setItemsAsNotBusy(publications));

		};

		/**
		 *
		 */
		$scope.unfavoritePublications = (responseStore, publications) => {

			if (!Array.isArray(publications)) publications = [ publications ];

			$http({
				...helper.http(API.publications, 'unfavorite'),
				method: 'PUT',
				data: {
					itens: publications
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(publications))

				.finally(() => responseStore.setItemsAsNotBusy(publications));

		};

		/**
		 *
		 */
		$scope.printPublications = publications => {

			if (!Array.isArray(publications)) publications = [ publications ];

			$state.go('root.default.publications.publicationsDetails', {
				publicationsIDs: publications.map(item => item.id).join(','),
				print: true
			});

		};

		/**
		 *
		 */
		$scope.downloadPublications = publications => {

			if (!Array.isArray(publications)) publications = [ publications ];

			window.open(helper.http(API.publications, 'download').url + '?IDs=' + publications.map(item => item.id).join(','), '_self');

		};

		/**
		 *
		 */
		$scope.archivePublications = (responseStore, publications) => {

			if (!Array.isArray(publications)) publications = [ publications ];

			$http({
				...helper.http(API.publications, 'archive'),
				method: 'PUT',
				data: {
					itens: publications
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(publications))

				.finally(() => responseStore.setItemsAsNotBusy(publications));

		};

		/**
		 *
		 */
		$scope.restorePublications = (responseStore, publications) => {

			if (!Array.isArray(publications)) publications = [ publications ];

			$http({
				...helper.http(API.publications, 'restore'),
				method: 'PUT',
				data: {
					itens: publications
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(publications))

				.finally(() => responseStore.setItemsAsNotBusy(publications));

		};

		/**
		 *
		 */
		$scope.setPublicationsAsRead = (responseStore, publications) => {

			if (!Array.isArray(publications)) publications = [ publications ];

			$http({
				...helper.http(API.publications, 'setAsRead'),
				method: 'PUT',
				data: {
					itens: publications
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(publications))

				.finally(() => responseStore.setItemsAsNotBusy(publications));

		};

		/**
		 *
		 */
		$scope.setPublicationsAsUnread = (responseStore, publications) => {

			if (!Array.isArray(publications)) publications = [ publications ];

			$http({
				...helper.http(API.publications, 'setAsUnread'),
				method: 'PUT',
				data: {
					itens: publications
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(publications))

				.finally(() => responseStore.setItemsAsNotBusy(publications));

		};

		/**
		 * Atualiza uma ou mais aplicações.
		 *
		 * @param {ResponseStore} responseStore - Instância de armazenamento de resposta.
		 * @param {Object[]|Object} items - Aplicação(ões) a ser(em) atualizada(s).
		 *
		 * @example
		 * // Cria uma instância de armazenamento de resposta.
		 * $scope.publications = helper.responseStore();
		 *
		 * // Atualiza o valor `foo` da aplicação de ID 0.
		 * $scope.updatePublications($scope.publications, {id: 0, foo: true});
		 *
		 * // Atualiza o valor `foo` das aplicações de ID's 0 e 1.
		 * $scope.updatePublications($scope.publications, [{id: 0, foo: true}, {id: 1, foo: true}]);
		 */
		$scope.updatePublications = (responseStore, items) => {

			responseStore.setItemsAsBusy(items);

			$('.modal').modal('hide');

			/** Caso `items` seja um unico item, cria um `Array` para ele. */
			if (!Array.isArray(items)) items = [ items ];

			$http({
				...helper.http(API.publications, 'PUT'),
				data: {
					itens: items
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'))

				.finally(() => responseStore.setItemsAsNotBusy(items));

		};

		/** Exibe o modal para edição de aplicação. */
		$scope.showEmployeeProfilesModal = (responseStore, item, id) => {

			const

				showModal = () => {

					$('#' + id)

						.modal('show')

						.off('hidden.bs.modal')

						.on('hidden.bs.modal', () => {

							responseStore

								.rowbackItems(item)

								.setItemAsNotEditable(item);

							if (!$scope.$$phase) $scope.$apply();

						});

				};

			responseStore

				.setItemAsEditable(item)

				.setSiblingItemsAsNotEditable(item);

			$scope.editableEmployeeProfile = responseStore.getItems().find(value => value.__editable__);

			if (!item.aplicacoes)

				$scope.recordEmployeeProfileDetails(responseStore, item, showModal);

			else showModal();

		};

		/***************************************************************/

		$http({
			...helper.http(API.userKeywords, 'GET'),
			params: {
				...helper.httpFields([
					'id',
					'palavraChave'
				])
			}
		})

			.then(response => $scope.userKeywords = response.data.itens);

		/***************************************************************/

		$http({
			...helper.http(API.userDiaries, 'GET'),
			params: {
				...helper.httpFields([
					'id',
					'diario'
				])
			}
		})

			.then(response => $scope.userDiaries = response.data.itens);

		/***************************************************************/

		/**
		 *
		 */
		$scope.openModalForwardPublications = () => {

			$('#modalForwardPublications').modal('show');

		};

		/**
		 *
		 */
		$scope.forwardPublications = (responseStore, publications, emails) => {

			if (!Array.isArray(publications)) publications = [ publications ];

			$http({
				...helper.http(API.publications, 'forward'),
				method: 'POST',
				params: {
					emails
				},
				data: {
					itens: publications
				}
			})

				.then(() => {});

		};

	}]);

/******************************************************************************/

import addPublicationsDeadlineTemplate from './partials/add-publications-deadline/add-publications-deadline.template.html';

import addPublicationsDeadlineController from './partials/add-publications-deadline/add-publications-deadline.controller.js';

application

	.directive('addPublicationsDeadline', () => ({
		restrict: 'E',
		templateUrl: addPublicationsDeadlineTemplate,
		controller: addPublicationsDeadlineController,
		transclude: true,
		link(scope, element, attrs, controller, transclude) {

			transclude(transcludeElement => element.prepend(transcludeElement));

		}
	}));

/******************************************************************************/

export default controller;
